import { render, staticRenderFns } from "./import-produtor.vue?vue&type=template&id=088dbe20&"
import script from "./import-produtor.vue?vue&type=script&lang=js&"
export * from "./import-produtor.vue?vue&type=script&lang=js&"
import style0 from "./import-produtor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports